/**
 *
 * This prepopulates the files in the forum/conversation page with query strings.
 */

var $ = require('./../sw-jquery');


module.exports = function($fragment) {

    function getQuery(query)
    {
        var URLSearchParams = new URLSearchParams();
        var params = new URLSearchParams(window.location.search);
        return params.get(query);
    }
// need to target element with ID here because we have no simple way to modify the element being created by Xenforo
// generally, use data-attributes for this if possible
    $fragment.swFindWithSelf('#XenForo').each(function() {
        //Because of same origin policy we don't have access to an iframe's child nodes so we have to modify it's contents like this:
        $('body p').innerHTML = 'Hello, \n I have a question regarding the ' + getQuery('title') + ' model';
    });

};
